import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import Cookies from 'js-cookie';
import { toaster } from 'evergreen-ui';
import axios from 'axios';
import moment from 'moment';
import api from '../../../../services/api';
import {
    Title,
    Inline,
	StyledReportShow,
} from './style';
import Card from '../../../../components/Campanhas/Card';
import { CampaignHeaderWithLinks } from '../../../../components/Campanhas/CampaignHeader';
import { TableHeader, TableCell } from '../../../../components/Campanhas/TableElements';
import DateSelect from '../../../../components/Campanhas/DateSelect';
import 'react-calendar/dist/Calendar.css';
import CampaignReport from '../../../../components/Campanhas/Reports/CampaignReport';
import { LoaderMain } from '../../../../components/Loader';


export default ({ match }) => {
	const { preSaleId, startParam, endParam } = match.params;
	// eslint-disable-next-line no-underscore-dangle
	const defaultEnd = moment()._d;
	// eslint-disable-next-line no-underscore-dangle
	const defaultStart = moment().subtract(30, 'day')._d;
	const [start, setStart] = useState(startParam !== undefined ? startParam : defaultStart);
	const [end, setEnd] = useState(endParam !== undefined ? endParam : defaultEnd);
	const [reportTemplates, setReportTemplates] = useState([]);
	const [reportId, setReportId] = useState([]);
    const [loaded, setLoaded] = useState(false);
	const [exportLoading, setExportLoading] = useState(false);
	const [campaign, setCampaign] = useState({});


	useEffect(() => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: 'Detalhes de relatório',
			},
			dataLayerName: 'Campanhas',
		});
	}, []);

	useEffect(() => {
		api.get(`/api/v2/briefings/${preSaleId}`)
			.then((response) => {
				const respData = response.data.data;
				const { attributes, relationships } = respData;
				const { answers } = relationships;
				const value = answers.filter(a => a.attributes.alias === 'value')
					.map(i => i.attributes.content);
				const channel = answers.filter(a => a.attributes.alias === 'channel')
					.map(i => i.attributes.content);
				attributes.value = value;
				attributes.channel = channel[0];
				setCampaign(attributes);
			});
	}, []);

	useEffect(() => {
		if (campaign.id !== undefined) {
			api.get(`/api/v2/reports/${campaign.id}/templates`)
				.then((response) => {
					if (response.status === 200) {
						setReportTemplates(response.data.data);
						setReportId(response.data.report_id);
						setLoaded(true);
					}
					return false;
				})
				.catch(() => {
					setLoaded(true);
					return toaster.danger(
						'Ops! Ocorreu um erro ao carregar seu relatório',
					);
				});
		}
	}, [campaign]);

	const exportReport = () => {
		if (reportTemplates.length === 0) {
			return toaster.danger(
				'Ops! Nenhum relatório encontrado para ser exportado.',
			);
		}

		setExportLoading(true);
		const queryStart = moment(start).format('YYYY-MM-DD');
		const queryEnd = moment(end).format('YYYY-MM-DD');

		const params = {
			responseType: 'arraybuffer',
			headers: {
				Accept: 'application/pdf',
				token: Cookies.get('CockpitLogged'),
				frontURL: process.env.REACT_APP_URL,
			},
			params: {
				startParam: queryStart,
				endParam: queryEnd,
			},
		};

		return axios.get(`${process.env.REACT_APP_PUPPETEER_URL}/export-pdf/relatorio/${campaign.id}`, params)
		.then((response) => {
			// handle success
			const blob = new Blob([response.data], { type: 'application/pdf' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = `relatorio-${campaign.id}.pdf`;
			link.click();
			setExportLoading(false);
		})
		.catch(() => {
			setExportLoading(false);
			return toaster.danger(
				'Ops! Ocorreu um erro ao exportar seu relatório.',
			);
		});
	};

	const loadedData = () => {
		if (reportTemplates.length > 0) {
			const queryStart = moment(start).format('YYYY-MM-DD');
			const queryEnd = moment(end).format('YYYY-MM-DD');

			return (
				<CampaignReport
					startDate={queryStart}
					endDate={queryEnd}
					reportTemplates={reportTemplates}
					setReportTemplates={setReportTemplates}
					channel={campaign.channel}
					reportId={reportId}
					exportReport={exportReport}
					exportLoading={exportLoading}
				/>
			);
		}
		return false;
	};

    return (
	<>
		<div style={{ padding: '30px 30px 0' }}>
			<CampaignHeaderWithLinks>Relatórios</CampaignHeaderWithLinks>
		</div>
		<StyledReportShow
			className="container-report"
			style={{
				width: '100%',
				padding: '0 30px 30px',
			}}
		>
			<div className="mb-5">
				<Card contentMargin="0px" borderRadius="5px">
					<Title>
						Detalhes da campanha recorrente
					</Title>
					<div
						className="row"
						style={{ padding: '0 20px', marginBottom: '10px' }}
					>
						<div className="col-3" style={{ padding: '0' }}><TableHeader>id campanha</TableHeader></div>
						<div className="col-3" style={{ padding: '0' }}><TableHeader>contratada em</TableHeader></div>
						<div className="col-2" style={{ padding: '0' }}><TableHeader>valor</TableHeader></div>
						<div className="col-2" style={{ padding: '0' }}><TableHeader>campanha</TableHeader></div>
						<div className="col-2" style={{ padding: '0' }}><TableHeader>status</TableHeader></div>
					</div>
					<div
						className="row"
						style={{ padding: '0 20px' }}
					>
						<div className="col-3" style={{ padding: '0' }}><TableCell>{campaign.id}</TableCell></div>
						<div className="col-3" style={{ padding: '0' }}><TableCell>{campaign.date}</TableCell></div>
						<div className="col-2" style={{ padding: '0' }}><TableCell>R${campaign.value},00/mês</TableCell></div>
						<div className="col-2" style={{ padding: '0' }}><TableCell>{campaign.channel}</TableCell></div>
						<div className="col-2" style={{ padding: '0' }}><TableCell>{campaign.status}</TableCell></div>
					</div>
				</Card>
			</div>
			<Card contentMargin="0px" borderRadius="5px" padding="25px">
				<Inline className="container-filter">
					<Title>Filtre a campanha na data desejada:</Title>
					<DateSelect
						start={start}
						setStart={setStart}
						end={end}
						setEnd={setEnd}
					/>
				</Inline>
				{
					loaded
					? (
						loadedData()
					) : <LoaderMain />
				}
			</Card>
		</StyledReportShow>
	</>
    );
};
